import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { licenceStatusSelector } from '../selectors/wizardSelectors';
import LicenceError from '../components/LicenceError/LicenceError';

const mapStateToProps = createStructuredSelector({ errorCode: licenceStatusSelector });

export default connect(mapStateToProps, null)(LicenceError);
